import React, { ReactNode } from 'react';
import Head from 'next/head';
import ArticleHero from '../../components/articleHero';
import TagList from '../../components/tagList';
import BannerAd from '../../components/ad/banner';
import SideAds, { BlockAdsOne, BlockAdsTwo } from '../../components/sideAds';
import Layout from '../../components/layout';
import { SEOFromQL } from '../../components/seo';
import SponsoredHeader from '../../components/sponsoredHeader';
import SocialSharing from '../../components/socialSharing';
import ArticleAuthor from '../../components/articleAuthor';
import getTitleFromPage from '../../utils/data/getTitleFromPage';
import { contentWpToCF } from '../../utils/data/cdn';

interface Props {
  menus: WordpressHeaderMenu[];
  page: WordpressArticlePage;
  error?: any;
  adverts: KeyedAdverts;
  displayPublishDate?: boolean;
  children?: ReactNode;
  childrenBeforeAuthor?: ReactNode;
  childrenBeforeTags?: ReactNode;
  articleHasBeenSponsored?: boolean;
  tags?: WordpressTag[];
}

const Article = ({
  page,
  menus,
  adverts,
  children,
  childrenBeforeAuthor,
  childrenBeforeTags,
  displayPublishDate = false,
  articleHasBeenSponsored = false,
  tags
}: Props) => {
  const title = getTitleFromPage(page.title);
  return (
    <>
      <Head>
        <title key='title'>{title}</title>
        <SEOFromQL
          seo={page.seo}
          ogImage={page.articleImage.thumbnail?.mediaItemUrl}
        />
      </Head>
      <Layout menus={menus}>
        <ArticleHero
          title={page.title}
          image={page.articleImage.thumbnail?.mediaItemUrl}
          publishDate={displayPublishDate ? page.date : undefined}
        />
        <BannerAd className='my-4' advert={adverts['banner-top']} />
        <div className='grid grid-cols-2 gap-0 mb-4 md:grid-cols-4 sm:gap-4'>
          <div className='col-span-2 my-4 md:col-span-3 md:my-0 article'>
            <SponsoredHeader
              articleHasBeenSponsored={articleHasBeenSponsored}
            />

            <article
              className='mb-4'
              dangerouslySetInnerHTML={{
                __html: contentWpToCF(page.content)
              }}
            />
            {childrenBeforeAuthor}
            <ArticleAuthor
              className='col-span-2 md:col-span-1'
              author={page.articleAuthor.author}
              oneOffAuthor={
                !page.articleAuthor.useSavedAuthor
                  ? page.articleAuthor.oneOffAuthor
                  : undefined
              }
            />
            <SocialSharing className='mt-4' />
            {childrenBeforeTags}
            <TagList tags={tags} className='my-4' />
            {children}
          </div>

          <SideAds adverts={adverts} />
          <BlockAdsOne adverts={adverts} />
          <BlockAdsTwo adverts={adverts} />
        </div>
      </Layout>
    </>
  );
};

export default Article;
